// EmployeesPage.jsx
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getEmployees } from "../features/employees/employeeSlice";
import { Col, Container, Row } from "react-bootstrap";
import EmployeesList from "./EmployeesList";
import EmployeeDetails from "./EmployeeDetails";
import { Typography } from "@mui/material";
import { login, logout } from "../features/auth/authSlice";

const EmployeesPage = () => {
  const { employees, isLoading, isSuccess, isError, message } = useSelector(state => state.employees);
  const { user, isSuccessAuth, isErrorAuth } = useSelector((state) => state.auth);
  const { UpdateEntryisSuccess, UpdateEntryisLoading, CreateEntryisSuccess, CreateEntryisLoading } = useSelector((state) => state.entries);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const dispatch = useDispatch();

const [state, setState] = useState({
  email: "",
  password: "",
  showPinEntry: false,
  showTimeEntryButtons: false,
  currentEmployeeId: null,
  selectedEmployeeStatus: null,
  });


  const handleEmployeeClick = (employee) => {
    if(user){
      // console.log('need to clock out previous user')
      dispatch(logout());
    }
    setSelectedEmployee(employee);
  };

  const handleBackClick = ()=>{
    setSelectedEmployee(null);
    dispatch(logout())
  }

  const handleLogout = () => {
    dispatch(logout());
    setSelectedEmployee(null);
  };


  useEffect(() => {
    if(UpdateEntryisSuccess || CreateEntryisSuccess){
      handleLogout();  
    }
  },[UpdateEntryisSuccess, CreateEntryisSuccess]);


  return (
    <Container>
      {selectedEmployee ? (
        <EmployeeDetails
          selectedEmployee={selectedEmployee}
          handleClick={() => handleBackClick()}
          employee={employees}
        />
      ) : (
        <EmployeesList 
          employees={employees} 
          handleEmployeeClick={handleEmployeeClick} 
        />
      )}
    </Container>
  );
};

export default EmployeesPage;




